const moneyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const integerFormatter = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 0,
});

export function formatMoney(cents: number | null | undefined): string {
  return moneyFormatter.format((cents ?? 0) / 100);
}

export function formatInteger(value: number | null | undefined): string {
  return integerFormatter.format(value ?? 0);
}

export function toDate(value: Date | string | number | null | undefined): Date | null {
  if (value == null) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatDate(
  value: Date | string | number | null | undefined,
  options: Intl.DateTimeFormatOptions = { month: "short", day: "numeric", year: "numeric" },
): string {
  const date = toDate(value);
  return date ? date.toLocaleDateString("en-US", options) : "-";
}

export function dateSortValue(value: Date | string | number | null | undefined): number {
  return toDate(value)?.getTime() ?? 0;
}
